import React from 'react'

interface ModalBackdropProps {
  isOpen: boolean
  onClose: () => void
  children?: React.ReactNode
  blurBackground?: boolean
  className?: string
}

export const ModalBackdrop: React.FC<ModalBackdropProps> = ({
  isOpen,
  onClose,
  children,
  blurBackground = true,
  className = '',
}) => {
  if (!isOpen) return null

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  return (
    <div 
      className={`fixed inset-0 z-50 flex items-center justify-center p-4 ${
        blurBackground ? 'backdrop-blur-md' : ''
      } bg-black/50 transition-all duration-300 ${className}`}
      onClick={handleBackdropClick}
      data-testid="modal-backdrop"
    >
      {children}
    </div>
  )
} 